import { Module } from 'vuex';
import AvsInBasket from '@/visa-application/models/AvsInBasket';
import { setLocalStorage } from '@/shared/utils/utils';

export const basketStore: Module<any, any> = {
  state: {
    basket: [],
    skipPay: false
  },
  getters: {
    getBasket: state => (): AvsInBasket[] => state.basket,
    isAvsIntoBasket: state => (avsInBasket: AvsInBasket): boolean => {
      return state.basket.some(item => {
        return item.fId === avsInBasket.f_id && item.avs.avs.sku === avsInBasket.avs.avs.sku;
      });
    },
    getAvsList: state => (): [] => state.basket.map(avs => avs.fId + ':' + avs.avs.avs.sku)
  },
  mutations: {
    addAvsToBasket(state, item: AvsInBasket): void {
      state.basket.push(item);
    },
    removeAvsFromBasket(state, avsInBasket: AvsInBasket): void {
      const index = state.basket.map(e => e.fId + ':' + e.avs.avs.sku).indexOf(avsInBasket.fId + ':' + avsInBasket.avs.avs.sku);
      state.basket.splice(index, 1);
    },

    replaceBasketWithAvsList(state, items: AvsInBasket[]): void {
      state.basket = items;
    },
    setSkipPay(state, payload: boolean) {
      state.skipPay = payload;
    }
  },
  actions: {
    addAvsToBasket(context, item: AvsInBasket): void {
      if (context.getters.isAvsIntoBasket(item)) {
        throw 'Avs ' + item.avs.avs.sku + ' is already in the basket.';
      }
      context.commit('addAvsToBasket', item);
      setLocalStorage('avsBasket', this.getters.getAvsList);
    },
    removeAvsFromBasket(context, item: AvsInBasket): void {
      if (!context.getters.isAvsIntoBasket(item)) {
        throw 'No AVS ' + item.avs.avs.sku + ' in the basket.';
      } else {
        context.commit('removeAvsFromBasket', item);
        setLocalStorage('avsBasket', this.getters.getAvsList);
      }
    },
    skipTlsPay(context, payload: boolean) {
      context.commit('setSkipPay', payload);
      setLocalStorage('skipPay', payload);
    }
  }
};
